import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';

import * as ReactSpark from "react-spark";
import { SubmitButton } from '../../../button/Button';

const { Type } = ReactSpark;

class ContinueButton extends Component {
    render() {
        const { id, onClick, loading, text, showCreditWarning } = this.props;
        return (
            <Fragment>
                <SubmitButton
                    id={id}
                    onClick={onClick}
                    loading={loading}
                    name="continueButton"
                >
                    {text}
                </SubmitButton>
                <br />
                {showCreditWarning && (
                    <Type.BodyFour>Won&#39;t affect your credit score.</Type.BodyFour>
                )}
            </Fragment>
        );
    }
}

ContinueButton.defaultProps = {
    showCreditWarning: false,
    onClick: () => {},
};

ContinueButton.propTypes = {
    id: PropTypes.string.isRequired,
    text: PropTypes.string.isRequired,
    onClick: PropTypes.func,
    loading: PropTypes.bool.isRequired,
    showCreditWarning: PropTypes.bool,
};

export default ContinueButton;
